import Model from '@/store/model';

class Audio extends Model {
  map(json) {
    super.map(json);
    this.url = this.url?.replace('http://', 'https://');
  }
}
export default Audio;
